export default function ProductSelectorComponent(module) {
    angular.module(module)
        .component('productSelector', {
            bindings: {
                datepickerPlaceholder: '@',
                productPickerPlaceholder: '@',
                serialNumbersPlaceholder: '@',
                selectionsLabel: '@',
                addButtonText: '@',
                clearButtonText: '@',
                onChange: '&?'
            },
            require: {
                ngModel: '?ngModel'
            },
            template: `
                <div class="inputs grid-x grid-margin-x small-up-1 medium-up-2">
		            <div class="options cell">
                        <input type="text" class="datepicker" autocomplete="off" readonly="readonly" placeholder="{{vm.datepickerPlaceholder}}" />
                        <div class="datepicker-container"></div>
                        <span class="field-validation-error" ng-if="vm.errors.purchaseDate">{{vm.errors.purchaseDate}}</span>
			            <select ng-model="vm.options.product" ng-change="vm.updateErrorStatus()">
				            <option selected value="">{{vm.productPickerPlaceholder}}</option>
                            <option ng-repeat="option in vm.products">{{option}}</option>
			            </select>
                        <span class="field-validation-error" ng-if="vm.errors.product">{{vm.errors.product}}</span>
			            <textarea ng-model="vm.options.serialNumbers" placeholder="{{vm.serialNumbersPlaceholder}}" ng-change="vm.updateErrorStatus()"></textarea>
                        <span class="field-validation-error" ng-if="vm.errors.serialNumbers">{{vm.errors.serialNumbers}}</span>
		                <a class="button" ng-click="vm.addSelection()">{{vm.addButtonText}}</a>
		            </div>
		            <div class="selections cell">
			            <h6>{{vm.selectionsLabel}}</h6>
			            <ul class="no-bullet">
                            <li ng-repeat="selection in vm.selections">
                                {{selection.serialNumbers.join(', ')}} ({{selection.name}})
                            </li>
                        </ul>
		                <a class="button button--grey" ng-click="vm.clear()">{{vm.clearButtonText}}</a>
		            </div>
	            </div>
            `,
            controller: productSelectorController,
            controllerAs: 'vm'
        });
    var id = 1;
    productSelectorController.$inject = ['$http', '$timeout', '$filter', '$element', '$window', '$scope'];
    function productSelectorController($http, $timeout, $filter, $element, $window, $scope) {
        var vm = this;

        vm.$onInit = () => {
            vm._id = id++;
            vm.today = new Date();
            vm.ngModel.$viewChangeListeners.push(vm.updateViewModel);
            vm.options = {};
            $http.get('/api/formextensions/products/', {
                cache: true
            })
                .then((response) => {
                    vm.products = response.data;
                });
            $timeout(vm.updateViewModel);
            if ($window.Pikaday) {
                vm._initDatePicker();
            }
            else {
                $window.loadScript('/App_Plugins/UmbracoForms/Assets/moment/min/moment-with-locales.min.js', () => {
                    $window.loadScript('/App_Plugins/UmbracoForms/Assets/pikaday/pikaday.js', () => {
                        vm._initDatePicker();
                    });
                });
            }
        }

        vm.$onDestroy = () => {
            if (vm.datePicker) {
                vm.datePicker.destroy();
            }
        }

        vm.$onChanges = changes => {
            if (changes.options && changes.options.currentValue) {
                vm.updateViewModel();
            }
        }

        vm._initDatePicker = () => {
            var element = $element[0];
            var datePickerContainer = element.querySelector('.datepicker-container');
            vm.datePicker = new Pikaday({
                field: element.querySelector('.datepicker'),
                container: datePickerContainer ? datePickerContainer : undefined,
                yearRange: $window.umbracoFormsLocale.datePickerYearRange,
                i18n: $window.umbracoFormsLocale.locales,
                format: "MM/D/YYYY",
                onSelect: function (date) {
                    $scope.$evalAsync(() => {
                        vm.options.purchaseDate = $filter('date')(date, 'yyyy-MM-dd');
                        vm.updateErrorStatus();
                    });
                },
                minDate: new Date('1753-01-01T00:00:00'), //Min value of datetime in SQL Server CE
                maxDate: new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate()),
                setDefaultDate: false
            })
        }

        vm.clear = () => {
            vm.updateViewModel(true);
            vm.updateModel();
        }

        vm.updateViewModel = (clear) => {
            if (clear || !vm.ngModel.$viewValue) {
                vm.selections = [];
            }
            else {
                if (typeof (vm.ngModel.$viewValue) === 'string') {
                    vm.selections = JSON.parse(vm.ngModel.$viewValue);
                }
                else {
                    vm.selections = angular.copy(vm.ngModel.$viewValue);
                }
            }
        }

        vm.updateErrorStatus = () => {
            if (vm.checkErrors) {
                vm.isValid();
            }
        }

        vm.isValid = () => {
            vm.errors = {};
            if (!vm.options.purchaseDate) {
                vm.errors.purchaseDate = 'A purchase date must be set.';
            }
            if (!vm.options.product) {
                vm.errors.product = 'A product must be selected.';
            }
            if (!vm.options.serialNumbers) {
                vm.errors.serialNumbers = 'A serial number must be entered.'
            }
            else if (!vm.options.serialNumbers.match(/^((\d+(,\s*|\n)?)+|n\/a)+$/gmi)) {
                vm.errors.serialNumbers = 'Serial numbers must be numbers or "n/a" separated by newlines or commas.'
            }
            return Object.keys(vm.errors).length === 0;
        }

        vm.addSelection = () => {
            if (vm.isValid()) {
                if (!vm.selections) {
                    vm.selections = [];
                }
                vm.selections.push({
                    purchaseDate: vm.options.purchaseDate,
                    name: vm.options.product,
                    serialNumbers: vm.options.serialNumbers.split(/\s*(\n|,)+\s*/).filter(text => !text.match(/(\s|,)+/))
                });
                vm.updateModel();
                vm.checkErrors = false;
                vm.options = {};
                vm.datePicker.setDate(null);
            }
            else {
                vm.checkErrors = true;
            }
        }

        vm.updateModel = () => {
            if (vm.ngModel) {
                if (vm.selections.length) {
                    vm.ngModel.$setViewValue(angular.copy(vm.selections));
                }
                else {
                    vm.ngModel.$setViewValue(null);
                }
            }
            if (vm.onChange) {
                vm.onChange({
                    value: angular.copy(vm.selections)
                });
            }
        }
    }
}